<template>
  <div
    class="d-flex content-constraint align-center"
    :style="{ 'min-height': smAndDown ? 'unset' : '444px' }"
  >
    <v-col
      ref="bannerContent"
      cols="12"
      md="6"
      class="banner-content"
      :class="{ 'mobile-content': smAndDown }"
      :style="bannerStyle"
    >
      <h1
        v-if="fields.heading && fields.heading.length"
        class="secondary--text"
      >
        {{ fields.heading }}
      </h1>
      <ctf-rich-text
        v-if="fields.subHeading"
        class="pt-5"
        :document="fields.subHeading"
      />
      <ctf-link
        v-if="fields && fields.bannerLink"
        arrow-link
        :btn-id="fields.bannerLink.sys.id"
        :key="fields.bannerLink.sys.id"
      />
    </v-col>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import CtfLink from '@/components/snippets/ctf-link'

export default {
  name: 'BannerCard',
  components: {
    CtfLink
  },
  props: {
    fields: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      bannerStyle: {}
    }
  },
  computed: {
    ...mapState({
      pageHasSlantedBackground: state => state.layout.pageHasSlantedBackground
    }),
    smAndDown () {
      return this.$vuetify.breakpoint.smAndDown
    }
  },
  watch: {
    pageHasSlantedBackground: {
      handler: 'setBannerStyle',
      immediate: true
    },
    smAndDown: {
      handler: 'setBannerStyle'
    }
  },
  methods: {
    setBannerStyle () {
      setTimeout(() => {
        this.bannerStyle =
          this.pageHasSlantedBackground && this.$refs.bannerContent
            ? {
              margin: `43px 0 ${Math.floor(
                this.$refs.bannerContent.clientHeight / 2
              ) + 43}px`
            }
            : {}
      })
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "../../styles/variables";
  .banner-content {
    text-align: left;
    background-color: rgba($white, 0.8);

    &:not(.mobile-content) {
      padding: 33px 41px;
    }
  }
  .mobile-content {
    margin: 35px 0 !important;
  }
</style>
